import React from 'react';
import {AppContext} from "../../HomePage";

// The same brands the marketing site lists as clients, so the visitor sees the
// names that convinced them on www.pricerest.com again on the form. The files
// come from that site, resized to the height they render at here.
const customers = [
    {file: "samsung.jpg", name: "Samsung"},
    {file: "lego.jpg", name: "LEGO"},
    {file: "duracell.jpg", name: "Duracell"},
    {file: "karcher.jpg", name: "Karcher"},
    {file: "pirelli.jpg", name: "Pirelli"},
    {file: "hilti.jpg", name: "Hilti"},
    {file: "daikin.jpg", name: "Daikin"},
    {file: "kyocera.jpg", name: "Kyocera"},
    {file: "einhell.jpg", name: "Einhell"},
    {file: "razer.jpg", name: "Razer"},
    {file: "vileda.jpg", name: "Vileda"},
    {file: "davey.jpg", name: "Davey"},
    {file: "sfa.jpg", name: "SFA Group"},
    {file: "reliable.jpg", name: "Reliable"},
    {file: "hardline.jpg", name: "Hardline Nutrition"},
    {file: "flashybox.jpg", name: "FlashyBox"}
];

// Sliding client-logo strip, rendered in two places: the dark brand column on
// wide screens, and the bottom of the register form on phones (where the brand
// column collapses to a bare logo and the visitor would otherwise see no proof
// at all). The two never show at once -- each placement is hidden at the
// breakpoint the other owns -- so the list lives here rather than in both.
//
// eCOMSCANNER is white-labelled and never shows PriceRest's clients.
const AuthCustomerStrip = ({variant = "dark"}) => {

    const {t, host} = React.useContext(AppContext);

    if (host === "ecomscanner")
        return null;

    // The track holds the set twice: the -50% loop lands exactly on the start
    // of the second copy, so the slide repeats without a visible jump. Only the
    // first copy is announced; the duplicate is decorative.
    return <div className={"auth-ux__customers auth-ux__customers--" + variant}>
        <span className="auth-ux__customers-label">{t('login.customers_label')}</span>
        <div className="auth-ux__marquee">
            <div className="auth-ux__marquee-track">
                {[...customers, ...customers].map((customer, index) =>
                    <img key={index} src={"/assets/layout/images/brands/" + customer.file}
                         alt={index < customers.length ? customer.name : ""}
                         aria-hidden={index >= customers.length}/>)}
            </div>
        </div>
    </div>;
};
export default AuthCustomerStrip;
